export { default } from './stripAllHtml';
